import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLAYROOM_REWARDS_SECTION_PAGE_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, PLAYROOM_REWARDS_SECTION_PAGE_KEY, {
  PRS_TAB_MARKETPLACE: 'Catalog',
  PRS_TAB_HISTORY: 'History',
  PRS_STATUS_DELIVERED: 'Delivered on',
  PRS_STATUS_REQUESTED: 'Requested',
  PRS_ORDER_NUMBER: 'Order No. {{order}}',
  PRS_CTA_REWARD_TITLE: 'You have selected this item',
  PRS_CTA_REWARD_CANCEL: 'Cancel',
  PRS_CTA_REWARD_SOLICIT: 'Request',
  PRS_SECTION_MARKETPLACE_DESCRIPTION: 'Discover the rewards you can redeem for your efforts during your learning activities.',
  PRS_EXCHANGE_FAILED_TITLE: 'Redemption request failed!',
  PRS_EXCHANGE_FAILED_DESCRIPTION: 'An error has occurred, please try again later',
  PRS_EXCHANGE_FAILED_OK: 'OK',
  PRS_SECTION_MARKETPLACE_REDEEMING: 'Requesting',
  PRS_X_CREHANACOINS: '{{coins}} {{currencyName}}',
  PRS_MISSING_CREHANACOINS: 'Missing *{{coins}} {{currencyName}}* to redeem this reward',
  PRS_LIMIT_REMDEPTIONS_1: 'You have',
  PRS_LIMIT_REMDEPTIONS_2: 'available requests for this reward',
  PRS_WITHOUT_LIMITS: 'You can request this reward without limits',
  PRS_LIMIT_REARCH_REDEMPTIONS: 'You have reached the available limit for this reward',
  PRS_ACCEPT_TERMS_1: 'I accept the',
  PRS_ACCEPT_TERMS_2: 'terms and conditions',
  PRS_EXCHANGE_SUCCESFUL_TITLE: 'Successful exchange request!',
  PRS_EXCHANGE_SUCCESFUL_DESCRIPTION: 'Your administrator will contact you to coordinate the receipt of your reward.',
  PRS_EXCHANGE_SUCCESFUL_OK: 'Understood',
  PRS_CTA_EXCHANGE: 'Redeem',
  PRS_CTA_SEE_DETAIL: 'See detail',
  PRS_HISTORY_SECTION_DESCRIPTION: 'Your purchase history',
  PRS_EMPTY_TITLE: 'You have not applied for a reward yet',
  PRS_EMPTY_DESCRIPTION: 'Go to the marketplace to choose your reward',
  PRS_EMPTY_MARKETPLACE_TITLE: 'There are no rewards available at this time',
  PRS_AVAILABLE_COINS: 'If you redeem these points, you will have',
  PRS_AVAILABLE_STOCK: 'Only {{count}} item left',
  PRS_AVAILABLE_STOCK_plural: 'Only {{count}} items left'
});
export default en;